export const { ANALYTICS_METRIC_VIEWS, ANALYTICS_METRIC_CLICKS, ANALYTICS_METRIC_SHARES, ANALYTICS_METRIC_COPIES } = {
  ANALYTICS_METRIC_VIEWS: 'views',
  ANALYTICS_METRIC_CLICKS: 'clicks',
  ANALYTICS_METRIC_SHARES: 'shares',
  ANALYTICS_METRIC_COPIES: 'copies',
}
